module.exports = __webpack_public_path__ + "./fonts/62d3dea31b0dd19801fd97ea9bed42b5.woff2";